export default {
  namespaced: true,
  state: {
    fieldsForRequest: {},
  },
  mutations: {
    setFieldsForRequest(state, data) {
      state.fieldsForRequest = data;
    },
  },
  getters: {
    fieldsForRequest: state => state.fieldsForRequest || {},
  },
};
